{
  "$id": "wealthlane://forms/termination-rules",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../termination-rules.domain.json",
  "properties": {
    "isOptions": {
      "type": "boolean",
      "widget": "hidden",
      "default": false
    },
    "planId": {
      "type": "string",
      "widget": "hidden"
    },
    "terminationRules": {
      "type": "array",
      "title": "",
      "items": {
        "type": "object",
        "properties": {
          "participantTerminationTypeId": { "$ref": "module://termination-rules#properties/participantTerminationTypeId" },
          "terminationTypeName": { "$ref": "module://termination-rules#properties/terminationTypeName" },
          "terminationRuleSetId": { "$ref": "module://termination-rules#properties/terminationRuleSetId" },
          "expirationInMonths": {
            "$ref": "module://termination-rules#properties/expirationInMonths",
            "disabledWhen": { "field": "^isOptions", "equals": false }
          },
          "expirationInDays": {
            "$ref": "module://termination-rules#properties/expirationInDays",
            "disabledWhen": { "field": "^isOptions", "equals": false }
          },
          "cancelShareTypeId": {
            "$ref": "module://termination-rules#properties/cancelShareTypeId"
          },
          "awardAdjustmentMethodId": {
            "$ref": "module://termination-rules#properties/awardAdjustmentMethodId"
          }
        }
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_TERMINATION_RULES"
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "fetch": {
          "actionId": "FETCH_TERMINATION_RULES_INIT",
          "params": {
            "awardType": "{params.awardType}",
            "planId": "{params.planId}"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "FETCH_TERMINATION_RULES_INIT",
          "params": {
            "terminationRuleSetId": "{params.terminationRuleSetId}",
            "awardType": "{params.awardType}",
            "planId": "{params.planId}"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "FETCH_TERMINATION_RULES_INIT",
          "params": {
            "terminationRuleSetId": "{params.terminationRuleSetId}",
            "awardType": "{params.awardType}",
            "planId": "{params.planId}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
